import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import FeaturedServices from '../components/HomeComponents/FeaturedServices';

const strengths = [
  {
    label: 'Lighting',
    title: 'Custom projector headlamp & foglamp',
    description:
      'Fokus pada upgrade tampilan dan pencahayaan kendaraan dengan setup yang lebih presisi, lebih rapi, dan lebih sesuai karakter mobil.'
  },
  {
    label: 'Authorized',
    title: 'Dealer resmi @ups.waymaker',
    description:
      'Pilihan produk dan arah build dibuat lebih jelas untuk pelanggan yang mencari referensi part terpercaya dan hasil yang terkurasi.'
  },
  {
    label: 'Upgrade',
    title: 'Detailing, body kit, dan performance parts',
    description:
      'Konten diarahkan ke kebutuhan visual dan upgrade kendaraan, mulai dari coating, detailing, lampu aftermarket, sampai lini suspension dan tuning parts.'
  }
];

const specialties = [
  {
    name: 'Custom Projector Headlamp',
    description:
      'Pengerjaan difokuskan pada tampilan depan yang lebih tegas, output cahaya yang lebih matang, dan karakter lampu yang lebih personal.',
    image: '/media/instagram/services-projector-brio.jpg',
    alt: 'Upgrade projector headlamp mobil dari Instagram XSignature'
  },
  {
    name: 'Body Kit & Lampu Aftermarket',
    description:
      'Menunjukkan arah brand untuk upgrade tampilan eksterior dan lampu aftermarket yang bikin karakter kendaraan terasa lebih jadi.',
    image: '/media/instagram/aftermarket-stoplamp-calya.jpg',
    alt: 'Lampu aftermarket mobil dari Instagram XSignature'
  }
];

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="bg-slate-950 text-white">
        <div className="grid min-h-[calc(100svh-72px)] lg:grid-cols-[1.05fr_0.95fr]">
          <div className="flex items-start px-4 pb-16 pt-24 sm:px-6 sm:pt-28 lg:px-12 lg:pt-32 xl:px-16">
            <div className="max-w-2xl">
              <h1 className="text-4xl font-bold leading-[0.95] sm:text-5xl lg:text-6xl">
                Custom lampu dan upgrade kendaraan dengan fokus yang lebih spesifik.
              </h1>
              <p className="mt-6 max-w-xl text-base leading-8 text-slate-300 sm:text-lg">
                XSignature diarahkan untuk custom projector headlamp, foglamp, coating, detailing, body kit,
                lampu aftermarket, dan pilihan parts dari brand yang sudah dikenal di segmennya.
              </p>
              <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                <Link to="/services" className="btn btn-primary px-8">
                  Lihat Layanan <FiArrowRight className="ml-2" />
                </Link>
                <Link to="/login" className="btn btn-outline px-8">
                  Konsultasi Sekarang
                </Link>
              </div>
            </div>
          </div>

          <div className="relative min-h-[320px] lg:min-h-full">
            <img
              src="/media/instagram/home-headlamp-foglamp.jpg"
              alt="Custom projector headlamp dan foglamp dari Instagram XSignature"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(2,6,23,0.16),rgba(2,6,23,0.58))]" />
          </div>
        </div>
      </section>

      <section className="border-b border-slate-200 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
<h2 className="mt-5 text-3xl font-bold text-slate-950 md:text-4xl">
              Fokus brand sekarang diarahkan ke lighting upgrade dan parts pilihan.
            </h2>
          </div>

          <div className="mt-14 border-t border-slate-200">
            {strengths.map((item, index) => (
              <div
                key={item.title}
                className={`grid gap-4 py-7 md:grid-cols-[160px_220px_1fr] ${
                  index !== strengths.length - 1 ? 'border-b border-slate-200' : ''
                }`}
              >
                <div className="text-xs font-semibold uppercase tracking-[0.22em] text-primary">{item.label}</div>
                <h3 className="text-xl font-semibold text-slate-950">{item.title}</h3>
                <p className="max-w-2xl text-sm leading-7 text-slate-600 sm:text-base">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-slate-200 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
<h2 className="mt-5 text-3xl font-bold text-slate-950 md:text-4xl">
              Konten utamanya menonjolkan lampu custom, detailing, body kit, dan lampu aftermarket.
            </h2>
          </div>

          <div className="mt-12 grid gap-10 lg:grid-cols-2">
            {specialties.map((item) => (
              <div key={item.name} className="border-t border-slate-200 pt-5">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="h-[260px] w-full object-cover sm:h-[320px]"
                />
                <div className="mt-5">
                  <h3 className="text-xl font-semibold text-slate-950">{item.name}</h3>
                  <p className="mt-3 max-w-xl text-sm leading-7 text-slate-600 sm:text-base">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FeaturedServices />

      <section className="py-20">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 md:grid-cols-[1fr_auto] md:items-end lg:px-8">
          <div className="max-w-2xl">
            <h2 className="mt-5 text-3xl font-bold text-slate-950 md:text-4xl">
              Siap konsultasi untuk upgrade kendaraan Anda?
            </h2>
            <p className="mt-4 text-base leading-8 text-slate-600">
              Hubungi tim kami untuk diskusi kebutuhan custom headlamp, foglamp, detailing, atau pilihan parts yang paling sesuai.
            </p>
          </div>
          <Link to="/login" className="btn btn-primary px-8">
            Mulai Konsultasi <FiArrowRight className="ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
